import "./App.css";
import React from "react";
import Navbar from "./containers/Navbar";
import Blog from "./containers/Blog";
import Changelog from "./containers/Changelog";

import titlegif from "./images/title-gif.gif";
import blinkie1 from "./images/test-blinkie-1.gif";
import blinkie2 from "./images/test-blinkie-2.gif";
import blinkie3 from "./images/test-blinkie-3.gif";
import blinkie4 from "./images/test-blinkie-4.gif";

const NAVBAR = [
  { label: "home", redirect: "" },
  { label: "about", redirect: "TODO" },
  { label: "art", redirect: "TODO" },
  { label: "oc pages", redirect: "TODO" },
  { label: "guestbook", redirect: "TODO" },
  { label: "cool links", redirect: "TODO" },
  { label: "something", redirect: "TODO" },
  { label: "another thing", redirect: "TODO" },
];

const App = () => {
  const [blog, setBlog] = React.useState([]);
  const [changelog, setChangelog] = React.useState([]);

  React.useEffect(() => {
    fetch("./data/blog.json")
      .then((res) => res.json())
      .then((json) => setBlog(json))
      .catch((err) => console.log(err));

    fetch("./data/changelog.json")
      .then((res) => res.json())
      .then((json) => setChangelog(json))
      .catch((err) => console.log(err));
  }, []);

  return (
    <div id="all-page-content">
      <div id="sidebar">
        <nav className="sidebar-element">
          <div>
            <Navbar buttons={NAVBAR} />
          </div>
        </nav>
        <section className="sidebar-element" id="changelog">
          <h3>changelog</h3>
          <Changelog entries={changelog} />
        </section>
        <section className="sidebar-element" id="blinkies">
          <img className="blinkie" src={blinkie2} alt="blinkie"></img>
          <img className="blinkie" src={blinkie1} alt="blinkie"></img>
          <img className="blinkie" src={blinkie3} alt="blinkie"></img>
          <img className="blinkie" src={blinkie4} alt="blinkie"></img>
        </section>
      </div>
      <main>
        <header>
          <h3 className="subtitle" id="top-subtitle">
            welcome to the
          </h3>
          <img src={titlegif} alt="IMPZONE" id="title" />
          <h3 className="subtitle" id="bottom-subtitle">
            ...live on the internet dot com!
          </h3>
        </header>
        <section className="main-content" id="welcome">
          <h2>welcome</h2>
          <p>stuff abt me goes here???</p>
        </section>
        <section className="main-content" id="blog">
          <h2>blog</h2>
          <Blog posts={blog} />
          <p id="blog-end-text">-- the beginning of history --</p>
        </section>
      </main>
    </div>
  );
};

export default App;
